// extracted by mini-css-extract-plugin
export var dropdownButton = "_12-0";
export var fullWidthDropdownButton = "_12-1";
export var icon = "_12-3";
export var iconPlaceholder = "_12-2";
export var menuItemRow = "_12-9";
export var separator = "_12-e";
export var shortcutContainer = "_12-7";
export var shortcutContainerFilled = "_12-8";
export var shortcutIconLg = "_12-6";
export var shortcutIconMd = "_12-5";
export var shortcutIconSm = "_12-4";
export var submenuChevron = "_12-d";
export var submenuDropdown = "_12-a";
export var submenuTriggerRow = "_12-b";
export var submenuTriggerRowOpen = "_12-c";